import { render, staticRenderFns } from "./BurnCoinBonus.vue?vue&type=template&id=3699bdc8&scoped=true&"
import script from "./BurnCoinBonus.vue?vue&type=script&lang=js&"
export * from "./BurnCoinBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3699bdc8",
  null
  
)

export default component.exports